module.exports = __webpack_public_path__ + "static/bubblegame-9c96204f3c3b2d51fb39f70a7af00936.png";